export const allowHostParam = "allowHost";
export const autoJoinParamName = "autoJoinPeerV0";
export const autoJoinGroupParamName = "autoJoinGroupV0";
export const urlParamName = "url";
